import { z } from 'zod';
import { decimalPositivo, uuid } from './comun.ts';

export const tasaDTO = z.object({
  id: uuid,
  bcv: z.string(),
  paralela: z.string(),
  factor_divisa: z.string(),
  fuente: z.enum(['manual', 'dolarapi', 'seed']),
  vigente_desde: z.string(),
  creado_por: uuid.nullable(),
});
export type TasaDTO = z.infer<typeof tasaDTO>;

/**
 * La tasa vigente con el aviso de la tasa 2: cuándo la escribió la dueña por última vez y si ya pasó el plazo del
 * recordatorio (`tasa_recordatorio_horas`). Traer la BCV no cuenta: no toca la tasa 2.
 */
export interface TasaVigenteDTO extends TasaDTO {
  paralela_desde: string;
  paralela_vieja: boolean;
}

/**
 * Resultado de «Traer la BCV del día»: la tasa que queda vigente y qué pasó de verdad con la consulta.
 */
export interface BcvTraidaDTO extends TasaDTO {
  /** Fecha que da la fuente para esa tasa (empieza por AAAA-MM-DD), si la da. Puede no ser la de hoy. */
  fecha_bcv: string | null;
  /** BCV que regía antes de la consulta. */
  bcv_anterior: string;
  /** true: se registró una tasa nueva. false: la fuente dio la misma BCV que ya regía y no se escribió nada. */
  registrada: boolean;
}

/**
 * Tasas que escribe el superadmin: BCV y tasa 2 (paralela). El factor divisa ya no se teclea: el sistema lo calcula
 * como paralela ÷ bcv (regla de precios de la clienta, enmienda 2026-10-09 de la spec 05).
 */
export const tasaActualizarInput = z.object({
  bcv: decimalPositivo,
  paralela: decimalPositivo,
});
export type TasaActualizarInput = z.infer<typeof tasaActualizarInput>;
